import axios from "axios";
import { RecentlySearchedExperiencesResponse } from "redmond";
import { config, recentlyViewedAxiosCancelToken } from "../../config";
import { recentlySearchedApiPrefix } from "../../paths";

const END_POINT: string = `${recentlySearchedApiPrefix}/activities`;

export const fetchRecentlySearchedExperiences =
  async (): Promise<RecentlySearchedExperiencesResponse> => {
    try {
      const res = await axios.get(END_POINT, {
        baseURL: config.baseURL,
        cancelToken: recentlyViewedAxiosCancelToken.token,
      });
      return res.data;
    } catch (e) {
      if (axios.isCancel(e)) {
        // Handle cancellation - return empty response or throw a specific error
        // In this case we're mimicking the original behavior which doesn't reject
        // for cancel errors, but we need to return something
        return {} as RecentlySearchedExperiencesResponse;
      }
      throw e;
    }
  };
